/**
 * Who is looking at a server-rendered page (web plan W4.4).
 *
 * The SEO server renders every page for a guest (its HTML is shared through
 * the cache), and the render that hydrates that HTML must match it, so a
 * signed-in viewer is only known from the render after hydration: the session
 * (`useAuth`, a `useSyncExternalStore` with a guest server snapshot) and
 * `useIsClient` both read the server snapshot until then. Pages use it to
 * load what only the viewer has (their favourites and follows) after mount,
 * never in the server HTML.
 */
import { useAuth } from '@/context/AuthContext';
import { useIsClient } from '@/hooks/useIsClient';

export interface ViewerState {
  /** False on the server and while hydrating; then whether someone is signed in. */
  isSignedIn: boolean;
  /** The signed-in user's id, else null. */
  userId: string | null;
}

export function useViewerState(): ViewerState {
  const { user } = useAuth();
  const isClient = useIsClient();
  const signedIn = isClient && user !== null;
  return { isSignedIn: signedIn, userId: signedIn ? user.id : null };
}
